module.exports = __webpack_public_path__ + "a19e6cef8aa6fc6709e6643f8bc54802.png";